import type { DefaultPaginatedFilters } from "@/api/shared/filters";

export interface TPatientNextVisit {
  id: string;
  patient: string;
  review_oral_health_instruction: boolean;
  review_weartime_instruction: boolean;
  review_rubber_bands_wear: boolean;
  review_dm_app: boolean;
  review_dm_app_take_first_scan: boolean;
  review_dm_app_review_scan_instructions: boolean;
  i_o_scan_update: boolean;
  x_ray_update: boolean;
  review_attachment_form: boolean;
  review_attachment_form_remove_attachments: boolean;
  review_attachment_form_replace_attachments: boolean;
  ipr_review: boolean;
  manicure_teeth: boolean;
  occlusal_adjustment: boolean;
  notes: string | null;
  confirmed_at?: string | null;
  completed_at?: Date | null;
}

export enum TNextVisitMarkType {
  CONFIRM = "confirm",
  COMPLETED = "completed",
}

export interface IPatientNextVisitFilter extends DefaultPaginatedFilters {
  patient?: string;
}
